<template>
	<div class="sortable-list-adder">
		<div class="content">
			<slot />
		</div>
		<div class="actions">
			<button type="button" :disabled="invalid" @click="$emit('add')">
				<div v-if="busy" class="busy"></div>
				<template v-else>Add</template>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SortableListAdder',
	props: {
		invalid: Boolean,
		busy: Boolean,
	},
	methods: {
		add() {
			this.$emit('add')
		},
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.sortable-list-adder {
	@extend %flex-col-center;
	align-items: stretch;
	width: 100%;
	background-color: $grey-95;

	.content {
		flex-grow: 1;
	}

	.actions {
		width: 100%;
		padding: 0 0.5rem 0.5rem;
	}

	button {
		@include button--no-pad;
		width: 100%;

		.busy {
			@include spinner--centered(1.5rem, $white);
			position: absolute;
			top: 50%;
			left: 50%;
		}
	}

	@include mq(md) {
		flex-direction: row;
		align-items: center;

		.actions {
			width: 8rem;
			padding: 0 0.5rem 0 0;
		}
	}
}
</style>
